import React from "react";
import "./FashionLookBook.css";
import fashionImg from "../Images/newcollection2.jpg";

const FashionLookBook = () => {
  return (
    <section className="fashion-section">

      {/* Decorative Elements */}
      <div className="vertical-line"></div>
      <div className="vertical-line2"></div>

      <div className="shape shape1"></div>
      <div className="shape shape2"></div>
      <div className="shape shape3"></div>

      <div className="line line1"></div>
      <div className="line line2"></div>
      <div className="line line3"></div>

      <div className="fashion-container">

        {/* Left Side */}
        <div className="fashion-content">

          <span className="sub-title">
            NEW COLLECTION
          </span>

          <h1>
            Fashion Afrique
            <br />
            
          </h1>

          <p>
            Discover premium African fashion designs with elegant styles,
            luxury fabrics, and modern trends for every occasion.
          </p>

          <button className="shop-btn">
            Explore Collection
          </button>

        </div>

        {/* Right Side Image */}
        <div className="fashion-image">

          <div className="image-wrapper">

            <div className="border-box"></div>

            <img
              src={fashionImg}
              alt="Fashion Lookbook"
            />

          </div>

        </div>

      </div>

    </section>
  );
};

export default FashionLookBook;